import { TFunction } from "i18next";
import { Setting } from "model/Workgroup";
import { useMemo } from "react";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

type MenuItem = {
  text: string;
  path: string;
  image: string;
};

export const useMenuList = (
  userType: string | null,
  t: TFunction,
): MenuItem[] => {
  const [companyState] = useCompanyStore();

  const havePublicModule = useMemo(() => {
    return (
      companyState.companySettings?.find(
        (s: Setting) => s.key === "CompanyShowPublicGigModule",
      )?.value == "true"
    );
  }, [companyState.companySettings]);

  return useMemo(() => {
    switch (userType) {
      case "Company":
        return [
          /*{
            text: t("CompanyOverview.Overview"),
            path: "/company/dashboard",
            image: "eye",
          },*/
          {
            text: t("CalendarCompany.Calendar"),
            path: "/company/calendar",
            image: "calendar",
          },
          {
            text: t("CalendarCompany.Schedule"),
            path: "/company/schedule",
            image: "calendar",
          },
          {
            text: t("GigsCompany.Gigs"),
            path: "/company/gigs",
            image: "document",
          },

          ...(havePublicModule
            ? [
                {
                  text: t("ApplicationsCompany.Recruit"),
                  path: "/company/applications",
                  image: "idbadge",
                },
              ]
            : []),

          {
            text: t("OrganizationalStructure.OrganizationalStructure"),
            path: "/company/organizationalStructure",
            image: "company",
          },
          {
            text: t("Salary.Salary"),
            path: "/company/salary",
            image: "wallet",
          },
          {
            text: t("CompanyTimeReport.TimeReports"),
            path: "/company/time-reports",
            image: "clock",
          },
        ];

      case "Employee":
        return [
          {
            text: t("CompanyEmployee.Schedule"),
            path: "/employee/schedule",
            image: "calendar",
          },
          {
            text: t("CompanyProfile.Profile"),
            path: "/employee/profile",
            image: "person",
          },
        ];

      default:
        return [];
    }
  }, [userType, t, havePublicModule]);
};
